module.exports = __webpack_public_path__ + "static/media/teatro@3x.70d80608.png";